const getRequestHandler = require('fitt-shell/getRequestHandler')
const httpConfig = require('../../config').http
const requestHandler = getRequestHandler(
  {
    config : httpConfig   
  }
)

module.exports = requestHandler



// WEBPACK FOOTER //
// ./lib/requestHandler.js